import { SettlementApproveDialog } from './SettlementApproveDialog';

/**
 * REVIEW, THEN APPROVE — the claims register's ✓.
 *
 * It is the same settlement dialog the claim page and the approvals hub open: the whole claim with its proof,
 * the amount to approve, and the server's settlement of it (wallet first, then collection cash, the rest
 * reimbursed). One dialog, so a claim can never be approved on different terms depending on where the
 * approver happened to click.
 */
export function ApproveExpenseReportModal({ reportId, onClose }: { reportId: string; onClose: () => void }) {
  return <SettlementApproveDialog reportId={reportId} onClose={onClose} />;
}
